import { RouteBuilders } from "@simplyk/common";
import { useRouter } from "next/router";

import { useLocaleContext } from "../../../../common/contexts/LocaleContext";

import { useUrlBuilder } from "@/common/hooks/useUrlBuilder";

/**
 * @deprecated Use useLiveFormEditorExit for Live Form Editor navigation
 * This hook is kept for legacy stepper-based form editors
 */
export const useBackToFormTable = () => {
  const router = useRouter();
  const buildUrl = useUrlBuilder();
  const { isoLocale } = useLocaleContext();

  const backToFormTableUrl = buildUrl({
    route: RouteBuilders.buildCampaignListLink({ isoLocale }),
  });

  const backToFormTable = async () => {
    await router.push(backToFormTableUrl);
  };

  return { backToFormTable, backToFormTableUrl };
};
